/**
 * UN FALLO DE CARGA NO ES UN VACÍO (ley de la casa; auditoría 2026-09-15: 32 `catch { setX([]) }`
 * convertían un error en un "no hay nada" creíble).
 *
 * En vez de que cada pantalla invente su franja roja, el sitio que falla avisa con
 * `avisarFalloDeCarga('archivo', () => load())` y la barra global (FalloDeCargaBar, montada en
 * AppShell) lo muestra con su botón de reintentar. La lista puede quedar vacía en pantalla, pero
 * la persona ve que fue un fallo y puede volver a pedirlo.
 */
export type FalloDeCarga = { clave: string; reintentar?: () => void; at: number };

export const EVENTO_FALLO = 'carga:fallo';

export function avisarFalloDeCarga(clave: string, reintentar?: () => void): void {
  try {
    window.dispatchEvent(new CustomEvent<FalloDeCarga>(EVENTO_FALLO, { detail: { clave, reintentar, at: Date.now() } }));
  } catch { /* sin window (tests) */ }
}
